// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"caaba7f7","126":"5712c93a","171":"41fa0e93","388":"02adc571","453":"ce79547e"}[chunkId] + ".chunk.js";
};